import { redirect } from 'react-router-dom';
import { getParamsFromStoreRedux } from 'store/utils';
import {
  getPostFlowUrl,
  getReturnUrlFromRequestLoader,
} from 'utils/common/route';
import { ensureUserInfoLoaded } from 'utils/loaderUtils';

export const changePasswordUnlockLoader =
  (queryClient) =>
  async ({ request }) => {
    const returnUrl = getReturnUrlFromRequestLoader(request);
    const { getState, dispatch } = getParamsFromStoreRedux();

    if (!getState || !dispatch) {
      throw redirect('/login');
    }

    const { userInfo } = await ensureUserInfoLoaded({
      queryClient,
      returnUrl,
    });

    if (!userInfo) {
      return {
        loading: true,
        userInfo: null,
        returnUrl,
      };
    }

    const { changePasswordAtNextLogon } = userInfo;

    if (!changePasswordAtNextLogon) {
      const redirectUrl = getPostFlowUrl({
        type: 'change-password-unlock',
        returnUrl,
        dispatch,
      });
      return redirect(redirectUrl);
    }

    return {
      loading: false,
      userInfo,
      returnUrl,
    };
  };
